import React from 'react';
import { SupplierDetails } from './components/SupplierDetails';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <SupplierDetails data-id="element-1" />
    </div>;
}